module.exports = __webpack_public_path__ + "img/mark-Folder1.e8cc43c.svg";